import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import NormalTable from "../../Component/NormalTable";
import { color } from "../../StyleData/Config";
import { masterAPI } from "../Masters/dataConfig";
import { axiosPrivate } from "../../axios/axios";

const MinQtyReportList = ({ isDialogOpen }) => {
  const [listData, setListData] = useState([]);

  useEffect(() => {
    if (isDialogOpen) {
      axiosPrivate
        .post(`${masterAPI["KPIReport"].getPartInventoryList}`, {})
        .then((res) => {
          setListData(res.data.result || []);
        })
        .catch((e) => {
          console.log(e);
          setListData([]);
        });
    }
  }, [isDialogOpen]);

  const columns = [
    { Header: "Part Code", accessor: "partCode" },
    { Header: "Part Name", accessor: "partName" },
    { Header: "Stock Room", accessor: "stockRoomName" },
    { Header: "Current Quantity", accessor: "currentQuantity" },
    { Header: "Min Quantity", accessor: "minQuantity" },
  ];

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
            px: 2,
            py: 1,
          }}
        >
          Min Qty Report
        </Typography>
      </Box>
      <Box sx={{ px: 2, py: 1 }}>
        <NormalTable data={listData} columns={columns} filt={true} />
      </Box>
    </>
  );
};

export default MinQtyReportList;
